"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIcon = void 0;
const react_1 = __importDefault(require("react"));
const Loading_styled_1 = require("./Loading.styled");
const LoadingIcon = () => (react_1.default.createElement(Loading_styled_1.StyledSpinner, { viewBox: "0 0 50 50" },
    react_1.default.createElement("circle", { className: "path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "6" })));
exports.LoadingIcon = LoadingIcon;
